// we import './bootstrap' like this
// to create an async boundary so that module federation can work
import('./bootstrap');

//adding to create a new release. need to remove this in next commit
